
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';

import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { FieldItemComponent } from '../field-item/field-item.component';
import { SharedModule } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { ButtonWithMenuActionComponent } from '../button-with-menu-action/button-with-menu-action.component';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { VisibilityService } from '@shared/services/visibility/visibility.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'subcontainer-multiple',
    templateUrl: './subcontainer-multiple.component.html',
    standalone: true,
    imports: [TooltipLawComponent, TooltipModule, SharedModule, FieldItemComponent, AfTranslatePipe, ButtonWithMenuActionComponent]
})
export class SubcontainerMultipleComponent implements OnInit, OnChanges, OnDestroy {
  isLanding: boolean = this.customLanding.isLanding();
  userPermissions: any = this.permissions.getPermissions();
  currentComponent: string = this.route.snapshot.data['componentName'];
  subscribers: any = {};
  subcontainerMultiple: any = {
    newEvaluatedFields: [],
    evaluated: [],
    itemOptions: {
      expandedMenu: [{
        icon: 'lf-icon-share',
        name: this.translate.instant('share-document.share-fieldcontainer'),
        action: 'shareFieldContainer'}]
    }
  }
  constructor(private route: ActivatedRoute,
    private modalService: ModalServiceService,
    private commonUtilsService: CommonUtilsService,
    private broadcastService: BroadcastService,
    private visibilityService: VisibilityService,
    private apiService: ApiServiceService,
    private permissions: UserPermisionsFactory,
    private translate: AfTranslateFactory,
    private customLanding: CustomLandingFactory,
    private loader: LoaderFactory) {}

  @Input() subContainer: any = null;
  @Input() subContainerMultiple: any = null;
  @Input() subcontainerDuplicated: any = null;
  @Input() concept: any = null;
  @Input() conceptLocked: any = null;
  @Input() evaluationProperties: any = null;
  @Input() isPrivate: any = null;
  @Input() evaluatedMap: any = null;
  @Input() viewMode: boolean = false;
  @Output() evaluatedConceptChange = new EventEmitter();
  @Output() saveBeforeCreate = new EventEmitter();
  @Output() launchAction = new EventEmitter();

  ngOnInit(): void {
    this.subscribers.changesInConceptBroadCast = this.broadcastService.subscribe('changes-in-concept', ()=>{
      let that: any =  this.subcontainerMultiple;
      if(that.fieldWithVisibility){
        this.visibilityService.configureListVisbleValue(that.fieldWithVisibility, that.evaluatedMap, that.concept);
      }
    })
  }

  ngOnChanges(): void {
    let that: any = this.subcontainerMultiple;
    that.subcontainerDuplicated = this.subcontainerDuplicated;
    that.concept = this.concept;
    that.conceptLocked = this.conceptLocked;
    that.subContainer = this.subContainer;
    that.isPrivate = this.isPrivate;
    if(this.evaluatedMap){
      this.configureMultiple();
    }
    that.lockedSubcontainer = that.concept && that.concept.saved && that.conceptLocked && !that.subContainer.private && !that.isPrivate;
  }

  generateDuplicate(itsSaveConcept:boolean = false){
    this.loader.openLoader('subcontainer-multiple-generate-duplicated');
    let that: any = this.subcontainerMultiple;
    this.apiService.add('conceptdata/'+that.concept.conceptObjectId+'/'+ that.subContainer.fieldContainerId +'/'+ 1)
      .then((data:any)=>{
        that.evaluatedFieldsMultiple = [...that.evaluatedFieldsMultiple, ...data];
        that.concept.evaluatedFields = [...that.concept.evaluatedFields, ...data];
        this.configureDuplicated(that.numSubContainerAmount+1);
        this.extractVisibilityMultiple();
        this.subContainerMultiple.delete(that.subContainer.fieldContainerId);
        this.subContainerMultiple.set(that.subContainer.fieldContainerId, that.subcontainerDuplicated);
        that.numSubContainerAmount++;
        this.loader.closeLoader(['subcontainer-multiple-generate-duplicated']);
        if(itsSaveConcept){
          this.configureMultiple();
        }
      }, (errorData:any)=>{})
  }

  configureMultiple(){
    let that: any = this.subcontainerMultiple;
    if(this.currentComponent !== 'editConcept'){
      that.evaluatedFieldsMultiple = [];
      that.evaluatedFieldsNoMultiple = [];
      that.concept.evaluatedFields.forEach((evaluatedField:any) => {
        if(evaluatedField.numSubContainer !== null && that.subContainer.fieldContainerId === evaluatedField.subContainerId){
          that.evaluatedFieldsMultiple.push(evaluatedField);
        }
      });
      that.numSubContainerAmount = that.evaluatedFieldsMultiple.length? that.evaluatedFieldsMultiple[that.evaluatedFieldsMultiple.length-1].numSubContainer : 0;
      if(that.subcontainerDuplicated.length !== that.numSubContainerAmount){
        for(let i = 1; i <= that.numSubContainerAmount; i++){
          this.configureDuplicated(i);
          this.subContainerMultiple.set(that.subContainer.fieldContainerId, that.subcontainerDuplicated )
        }
      }
    }else{
      let newSubcontainer:any = cloneDeep(that.subContainer);
      newSubcontainer.myId = this.commonUtilsService.createId();
      newSubcontainer.evaluatedFields = [];
      newSubcontainer.numSubContainer = 0;
      that.subcontainerDuplicated.push(newSubcontainer);
    }
    this.extractVisibilityMultiple();
  }

  configureDuplicated(index:any) {
    let newSubcontainer = cloneDeep(this.subcontainerMultiple.subContainer);
    newSubcontainer.myId = this.commonUtilsService.createId();
    newSubcontainer.subcontainerDuplicated = [];
    newSubcontainer.evaluatedFields = [];
    newSubcontainer.numSubContainer = index;
    newSubcontainer.fields.forEach((field:any) => {
      field.generateId = true;
      this.subcontainerMultiple.evaluatedFieldsMultiple.forEach((evaluatedMultiple:any) => {
        if(field.fieldId === evaluatedMultiple.fieldId && evaluatedMultiple.numSubContainer === index){
          field.evaluatedValue = evaluatedMultiple;
          newSubcontainer.evaluatedFields.push(evaluatedMultiple);
        }
      });
    });
    this.subcontainerMultiple.subcontainerDuplicated.push(newSubcontainer);
  }

  extractVisibilityMultiple(){
    let that: any = this.subcontainerMultiple;
    that.fieldWithVisibility = this.visibilityService.extractVisibilityMultiple(that.subcontainerDuplicated);
    that.fieldWithProperties = this.visibilityService.extractPropertiesVisibility(that.concept);
    if(this.currentComponent !== 'editConcept'){
      that.evaluatedMap = this.visibilityService.evaluatedFieldsMap(that.concept);
      this.visibilityService.configureListVisbleValue(that.fieldWithVisibility, that.evaluatedMap, that.concept);
      this.visibilityService.configureEvaluationProperties(that.fieldWithProperties, this.evaluationProperties);
    }
  }

  duplicateSubcontainer(){
    if(this.isLanding && !this.subcontainerMultiple.concept.conceptObjectId){
      this.saveBeforeCreate.emit();
    }else{
      this.generateDuplicate();
    }
  }

  deleteDuplicated(subContainer: any){
    this.modalService.infoModal({ text: this.translate.instant('subcontainer-multiple.delete-this-copy-question'), typeButtons: 'cancelRemove' })
      .subscribe((result:any)=>{
        if(result.result === 'ok'){
          this.loader.openLoader('subcontainer-multiple-delete-duplicated');
          this.deleteEntity(subContainer);
        }
      })
  }

  deleteEntity(subContainer:any){
    let that: any = this.subcontainerMultiple;
    this.apiService.delete('conceptdata/removemultiplesubgroup/'+that.concept.conceptObjectId+'/'+subContainer.fieldContainerId, subContainer.numSubContainer)
      .then((data:any)=>{
        let deleteItem = null;
        let duplicated = that.subcontainerDuplicated
        for(let i = 0; i < duplicated.length; i++){
          if(subContainer.myId === duplicated[i].myId){
            this.deleteEvaluatedFields(subContainer.fields);
            duplicated.splice(i, 1);
            deleteItem = i;
            break;
          }
        }
        that.numSubContainerAmount--;
        for(let j:any = deleteItem; j < duplicated.length; j++){
          duplicated[j].numSubContainer = j+1;
          for(let k = 0; k < duplicated[j].evaluatedFields.length; k++){
            duplicated[j].evaluatedFields[k].numSubContainer = duplicated[j].numSubContainer;
            for( let v = 0; v < that.evaluatedFieldsMultiple.length; v++){
              if(duplicated[j].evaluatedFields[k].conceptDataId === that.evaluatedFieldsMultiple[v].conceptDataId){
                that.evaluatedFieldsMultiple[v].numSubContainer = duplicated[j].numSubContainer;
              }
            }
          }
        }
        this.extractVisibilityMultiple();
        this.evaluatedConceptChange.emit({field: null});
        this.loader.closeLoader(['subcontainer-multiple-delete-duplicated']);
        this.modalService.successModal({ text: this.translate.instant('subcontainer-multiple.delete-this-copy-ok')})
      }, (errorData:any)=>{})
  }

  deleteEvaluatedFields(fields:any){
    let concept: any = this.subcontainerMultiple.concept;
    for(let i = 0; i < fields.length; i++){
      for(let j = 0; j < concept.evaluatedFields.length; j++){
        if(fields[i].evaluatedValue.conceptDataId === concept.evaluatedFields[j].conceptDataId){
          concept.evaluatedFields.splice(j, 1);
        }
      }
    }
    this.subcontainerMultiple.evaluatedFieldsMultiple = concept.evaluatedFields;
  }

  launchActionHeader(action: any, fieldContainer:any){
    if(action === 'shareFieldContainer'){
      this.launchAction.emit({action: action, fieldContainer: fieldContainer});
    }
  }

  changesInEvaluatedSubContainer(field:any){
    this.evaluatedConceptChange.emit({field: field});
    this.visibilityService.configureListVisbleValue(this.subcontainerMultiple.fieldWithVisibility, this.subcontainerMultiple.evaluatedMap, this.subcontainerMultiple.concept);
  }

  shareFieldContainer(subContainer:any){
    this.launchAction.emit({action: 'shareFieldContainer', fieldContainer: subContainer});
  }

  openRelatedInfo(relatedInfo:any){
    this.modalService.relatedInformationModal(relatedInfo);
  }

  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
  }
}
